import React from 'react';

import { theme } from 'antd';

const { useToken } = theme;

const PressureIcon = ({ fillColor }: { fillColor?: string }) => {
  const { token } = useToken();
  const currentFillColor = fillColor ?? token.colorBgContainer;

  return (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23 26.5C26.5899 26.5 29.5 23.5899 29.5 20C29.5 16.4101 26.5899 13.5 23 13.5C19.4101 13.5 16.5 16.4101 16.5 20C16.5 23.5899 19.4101 26.5 23 26.5ZM21.9986 17.6178C22.2913 17.4829 22.6082 17.4081 22.9303 17.398C23.2525 17.3879 23.5734 17.4426 23.874 17.5589C24.0216 17.616 24.1628 17.6874 24.2957 17.7718L23.4385 18.629C23.3021 18.5779 23.1544 18.55 23.0001 18.55C22.3098 18.55 21.7501 19.1096 21.7501 19.8C21.7501 20.4903 22.3098 21.05 23.0001 21.05C23.6905 21.05 24.2501 20.4903 24.2501 19.8C24.2501 19.6318 24.2169 19.4714 24.1567 19.325L26.0602 17.4215C26.2554 17.2263 26.2554 16.9097 26.0602 16.7144C25.8649 16.5192 25.5483 16.5192 25.3531 16.7144L25.015 17.0525C24.7752 16.8773 24.513 16.7339 24.2348 16.6263C23.8093 16.4616 23.355 16.3842 22.8989 16.3985C22.4428 16.4128 21.9943 16.5187 21.5799 16.7097C21.1655 16.9007 20.7938 17.1731 20.4867 17.5106C20.1796 17.848 19.9434 18.2438 19.7923 18.6743C19.6411 19.1048 19.5779 19.5613 19.6066 20.0167C19.6352 20.4721 19.7551 20.9171 19.959 21.3253C20.163 21.7335 20.4469 22.0965 20.7938 22.3928C21.0038 22.5722 21.3194 22.5473 21.4988 22.3374C21.6781 22.1274 21.6533 21.8118 21.4433 21.6324C21.1982 21.4231 20.9977 21.1667 20.8536 20.8783C20.7095 20.59 20.6248 20.2756 20.6046 19.9539C20.5844 19.6323 20.629 19.3098 20.7358 19.0057C20.8426 18.7015 21.0094 18.422 21.2263 18.1836C21.4432 17.9452 21.7059 17.7528 21.9986 17.6178Z"
      fill={currentFillColor}
    />
  );
};

export default PressureIcon;
